import dynamic from 'next/dynamic'
import { type FC } from 'react'

import { ErrorBoundary } from '../../../error-boundary'

const ProductOutOfStockCrossSellSliderWidget = dynamic(async () =>
  import('../ProductCrossSell/ProductCrossSellOutOfStockSliderWidget').then(
    (mod) => mod.ProductCrossSellOutOfStockSliderWidget,
  ),
)

export const ProductOverviewOutOfStockCrossSellSliderWidget: FC = () => {
  return (
    <ErrorBoundary>
      <ProductOutOfStockCrossSellSliderWidget
        className="tablet:hidden"
        itemsPerPage={3}
      />
    </ErrorBoundary>
  )
}
